import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import background from '../../assets/howto/background.png'
import Grid from '@mui/material/Grid2';
import factory from '../../assets/serve/factory.png'
import globe from '../../assets/serve/globe.png';
import shield from '../../assets/serve/shield.png'
import chartlineup from '../../assets/serve/chartlineup.png'

const TrustEmpayer = () => {
  // Data for the steps to improve maintainability
  const steps = [
    {
      icon: factory,
      title: "Industry expertise",
      description:
        "We understand the specific \n challenges of your sector \n and provide solutions that fit"
    },
    {
        icon: chartlineup,
      title: "Scalability",
      description:
        "Our platform will grow with \n your business whether you are \n a startup or an enterprise",
    },
    {
        icon: shield,
      title: "Compliance & Security",
      description:
        "We prioritize regulatory \n compliance and top-tier \n security standards",
    },
    {
        icon: globe,
        title: "Smart Integrations",
        description:
          "Adaptive APIs, routing, and \n cascading designed for \n optimized transactions",
      },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bgcolor: "rgb(50, 19, 56)", // dark-purple1
        borderRadius: "13px",
        maxWidth: "1420px",
        width: "100%",
        alignSelf: {xs: "stretch"}
      }}
    >

      <Box
        sx={{
          display: "flex",
          height: {md: "126px", sx: "98px"},
          alignItems: "center",
          justifyContent: {md: "space-between", sm: "center", xs: "center"},
          width: "100%",
          bgcolor: "#F7F4E7", 
          padding: {xs: "32px 20px", md: "0 48px"},
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          gap: {xs: '16px', md: '0'}
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            fontStyle: "normal",
            fontSize: { xs: "28px", md: "36px" },
            textWrap: "wrap",
          }}
        >
          <Box component="span" sx={{ color: "#321338" }}>
            WHY BUSINESSES{" "}
          </Box>
          <Box component="span" sx={{ color: "#9484ba" }}>
            TRUST{" "}
          </Box>
          <Box component="span" sx={{ color: "#321338" }}>
            EPAYR
          </Box>
        </Typography>
      </Box>

      <Container
      sx={{
            background: `url(${background});`, 
            maxWidth: "1420px !important",
            backgroundSize: 'cover', 
            backgroundPosition: 'center',
            padding: {md: '80px 0', xs: '40px 0'},
            display: 'flex',
            alignItems: {md: 'flex-start', sm: 'center', xs: 'center'},
            alignSelf: 'stretch',
            flexDirection: {md: 'row', sm: 'column', xs: 'column'},
        }}>
        <Grid container spacing={4} justifyContent="center" sx={{width: '100%'}}>
          {steps.map((step, index) => (
            <Grid
              key={index}
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                gap: {md: "32px", sm: "20px", xs: "20px"},
              }}
            >
              <Box
                width={{xs: "60px", sm: "80px"}}
                height={{xs: "60px", sm: "80px"}}
                display="flex"
                justifyContent="center"
                alignItems="center"
                borderRadius={{xs: "9px", sm: "12px"}}
                sx={{
                    background: "#DED4F6"
                }}
              >
                <Box component="img" src={step.icon} 
                    width={{xs: "36px", sm: "48px"}}
                    height={{xs: "36px", sm: "48px"}}
                    flexShrink={0}
                />
              </Box>

              <Stack alignItems="center" spacing={2}>
                <Typography
                  sx={{
                    color: "#F5F0E6", // beige-1
                    fontSize: "22px",
                    fontWeight: 500,
                    lineHeight: 1.2,
                    textAlign: "center",
                    whiteSpace: "pre-line",
                    textTransform: "uppercase"
                  }}
                >
                  {step.title}
                </Typography>

                <Typography
                  sx={{
                    color: "#B5A1B9", // dark-purple5
                    fontSize: "16px",
                    fontWeight: 500,
                    textAlign: "center",
                    whiteSpace: "pre-line",
                    textTransform: "uppercase"
                  }}
                >
                  {step.description}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Paper>
  );
};

export default TrustEmpayer;
